import React, { useContext } from "react";
import { Link } from "react-router-dom";
import ContextComponent from "../Context";
import { GrFormPreviousLink } from "react-icons/gr";

const HelpSidebar = ({ sidebar_title, data }) => {
  const context = useContext(ContextComponent);

  const handleAllCategoriesClick = () => {
    context.query_parameters["search_term"] = "";
  };
  const formatTitle = title =>
    title.replace(/\s+/g, "_").replace(/\u200C/g, "--");
  return (
    <div className="help-container category-container">
      <div className="justify-content-center mx-0">
        <p className="category-title">{sidebar_title}</p>
      </div>
      <hr />
      <div className="mx-0">
        <div className="custom-accordion w-100">
          <ul className="p-0">
            <Link
              style={{ fontSize: "17px" }}
              className="help-item category-link help-link"
              to="/help"
              onClick={handleAllCategoriesClick}>
              همه مطالب
              <GrFormPreviousLink className="category-link-icon" />
            </Link>
            {data.map(item => (
              <Link
              key={item.id}
                className="help-link help-item category-link"
                to={`/help/category/${formatTitle(item.title)}`}
                onClick={handleAllCategoriesClick}>
                <p className="category-link-title">{item.title}</p>
                <GrFormPreviousLink className="category-link-icon" />
              </Link>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HelpSidebar;
